/*
 * CAPTURE-OWNED MODULE
 * FeatureRequestButton — the header's "Feature Request" action, beside the
 * tenant switcher and user menu, so it is on every signed-in screen.
 */

import React, { useCallback, useRef, useState } from 'react';
import FeatureRequestDialog from './FeatureRequestDialog';
import './FeatureRequestDialog.css';

export default function FeatureRequestButton() {
  const [open, setOpen] = useState(false);
  const triggerRef = useRef(null);

  const close = useCallback(() => {
    setOpen(false);
    // Hand focus back to where it was before the dialog took it.
    if (triggerRef.current) triggerRef.current.focus();
  }, []);

  return (
    <>
      <button
        ref={triggerRef}
        type="button"
        className="frd-trigger"
        aria-haspopup="dialog"
        onClick={() => setOpen(true)}
      >
        Feature Request
      </button>
      {open && <FeatureRequestDialog onClose={close} />}
    </>
  );
}
